export function formatDateToDashed(d) {
    return d.split("T")[0];
}
export function formatDateToDot(d) {
    return d.split("T")[0].split("-").join(".");
}
export function formatDateToDashedYYYYMMDDHHMM(d) {
    return d.split("T")[0] + " " + d.split("T")[1].split(".")[0].slice(0, 5);
}
